import React, { useState, useEffect } from 'react';
import under from '../../assets/under.svg';
import avatar from '../../assets/avatar.png'; // Placeholder for testimonial images

function Testimonial() {
    // Hardcoded testimonials array with avatar image
    const testimonials = [
        {
            fullName: "Matic Kiebler",
            designation: "Realtor, Slovenia.",
            message: "Working with Synatrix was a great experience. They built a simple, easy-to-use website and app for our real estate business. It made it easier for our customers to browse listings and for us to manage content. Their work has really helped us stand out in Slovenia. Highly recommended!",
            image: avatar
        },
        {
            fullName: "Muhannad Dawoud",
            designation: "CCET, Saudi Arabia.",
            message: "Partnering with Synaptrix to create the CCET web and mobile app for students with special needs was a fantastic experience. The platform is intuitive, accessible, and tailored to our students' needs. It has made learning easier and more inclusive for many children in Saudi Arabia. We truly appreciate their dedication and expertise in bringing this vision to life.",
            image: avatar
        },
        // {
        //     fullName: "Jordan Sorcarser",
        //     designation: "Founder, OrgConnect",
        //     message: "Collaborating with Synaptrix to build our OrgConnect web app has been a fantastic experience. The app makes it easy for different organizations to manage dues, fundraisers, and events in one place. It’s user-friendly, efficient, and has improved how we engage with our communities. Synaptrix really brought our vision to life with their expertise and attention to detail.",
        //     image: avatar
        // }
    ];

    const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

    // Auto slide to next testimonial every 3 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTestimonialIndex((prevIndex) =>
                prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000);

        return () => clearInterval(interval); // Clear the interval on component unmount
    }, [testimonials.length]);

    // Select the current testimonial
    const testimonial = testimonials[currentTestimonialIndex];

    return (
        <div className="py-14">
            <div className="max-w-[80rem] px-8 mx-auto flex flex-col items-center justify-center">
                <h1 className="mt-5 text-3xl text-center font-bold text-gray-800 sm:text-5xl lg:text-6xl">
                    Fuel that {""}
                    <span className="relative inline-block">
                        <span className="absolute inset-0 bg-primary transform -rotate-2 z-0"></span>
                        <span className="relative z-10 font-bold px-2 py-1 mb-4 text-second">
                            Inspires
                        </span>
                        <img src={under} alt="underline" className='absolute' />
                    </span>
                    {""} us to excel
                </h1>
                <h1 className="text-gray-600 pt-8 text-center px-4 sm:px-0">
                    We are your trusted partner for a diverse range of IT needs, encompassing both IT products and services. Our proven track record of success across diverse industries demonstrates our ability to deliver tailored IT solutions and propel your business forward.
                </h1>

                {/* Testimonial Content Section */}
                <div className="flex flex-col lg:flex-row items-center justify-center space-y-8 lg:space-y-0 lg:space-x-8 mt-12">
                    <div className="bg-gradient-to-tl from-blue-100 to-violet-100 rounded-xl w-full lg:w-[75%] h-[40vh] p-8 flex flex-col justify-between">
                        <div>
                            <div className="flex items-start justify-start space-x-4 mb-4">
                                <img src={testimonial.image} alt="client" className="rounded-full w-16 h-16" />
                                <div>
                                    <h1 className="text-xl font-semibold">{testimonial.fullName}</h1>
                                    <h1 className="text-gray-600">{testimonial.designation}</h1>
                                </div>
                            </div>
                            <div className="flex space-x-1">
                                <i className="fa-solid fa-star text-yellow-400"></i>
                                <i className="fa-solid fa-star text-yellow-400"></i>
                                <i className="fa-solid fa-star text-yellow-400"></i>
                                <i className="fa-solid fa-star text-yellow-400"></i>
                                <i className="fa-solid fa-star-half text-yellow-400"></i>
                            </div>
                        </div>
                        <p className="text-gray-700 mt-4 overflow-y-auto">{testimonial.message}</p>
                    </div>

                    <a href='https://forms.gle/oG4r7zyiXpjNxujP8' className="bg-slate-100 border border-slate-200 rounded-xl h-[40vh] w-full lg:w-[25%] p-8 flex items-center justify-center flex-col">
                        <i className="fa-sharp-duotone fa-light fa-pen-to-square text-[6rem] text-slate-400 text-center"></i>
                        <h1 className="text-gray-600 pt-8 text-2xl font-semibold text-center">
                            Write a Review for Us
                        </h1>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Testimonial;